"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var chevron_up_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/chevron_up"));
var chevron_down_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/chevron_down"));
var LftListMenuItem_1 = __importDefault(require("../LftListMenuItem"));
var LftIconBase_1 = __importDefault(require("../LftIconBase"));
var LftListMenu_1 = __importDefault(require("../LftListMenu"));
var use_mobile_hook_1 = require("../../utils/hooks/use-mobile.hook");
var S = __importStar(require("./LftTabGroup.styles"));
var LftTabGroup = function (_a) {
    var bgColor = _a.bgColor, children = _a.children, _b = _a.currentTabindex, currentTabindex = _b === void 0 ? 0 : _b, dataSection = _a.dataSection, dataTestId = _a.dataTestId, id = _a.id, lftChange = _a.lftChange;
    var tabGroupRef = (0, react_1.useRef)(null);
    var _c = (0, react_1.useState)(currentTabindex), selectedTab = _c[0], setSelectedTab = _c[1];
    var _d = (0, react_1.useState)(false), tabMenuMobileOpen = _d[0], setTabMenuMobileOpen = _d[1];
    var tablet = (0, use_mobile_hook_1.useMobile)().tablet;
    var tabMenu = [];
    var tabMenuMobile = [];
    var dataElement = dataSection === null || dataSection === void 0 ? void 0 : dataSection.replace('section_', '');
    var _toggleMenuItems = function () {
        setTabMenuMobileOpen(!tabMenuMobileOpen);
    };
    var _selectItemMenuMobile = function (e) {
        setTabMenuMobileOpen(false);
        setSelectedTab(e.currentIndex ? e.currentIndex : 0);
    };
    (0, react_1.useEffect)(function () {
        setSelectedTab(currentTabindex);
    }, [currentTabindex]);
    (0, react_1.useEffect)(function () {
        lftChange &&
            lftChange({
                currentIndex: selectedTab,
            });
    }, [selectedTab, lftChange]);
    react_1.Children.map(children, function (child, index) {
        if ((0, react_1.isValidElement)(child)) {
            tabMenu.push((0, jsx_runtime_1.jsx)(S.TabButtonStyled, __assign({ "aria-controls": "panel-" + index, "aria-selected": selectedTab === index ? true : false, bgColor: bgColor, className: selectedTab === index ? 'active' : '', "data-element": child.props.dataElement ? "option_" + child.props.dataElement : dataElement && "option_" + (index + 1) + "-" + dataElement, "data-info": child.props.dataInfo, id: "tab-" + index, role: "tab", onClick: function () { return setSelectedTab(index); } }, { children: (0, jsx_runtime_1.jsx)("span", { children: child.props.title }, void 0) }), index));
            tabMenuMobile.push((0, jsx_runtime_1.jsx)(LftListMenuItem_1.default, __assign({ "aria-controls": "panel-" + index, dataElement: child.props.dataElement ? "option_" + child.props.dataElement : dataElement && "option_" + (index + 1) + "-" + dataElement, dataInfo: child.props.dataInfo, id: "menu-item-" + index, role: "tab" }, { children: child.props.title }), index));
        }
    });
    if (dataSection) {
        if (dataSection.startsWith('section_')) {
            console.warn('Não é necessário mais o prefixo section_ no atributo dataSection');
        }
        else
            dataSection = "section_" + dataSection;
    }
    return ((0, jsx_runtime_1.jsxs)(S.TabContainerHostStyled, __assign({ "data-testid": dataTestId ? dataTestId : id && id, id: id }, { children: [(0, jsx_runtime_1.jsx)(S.TabContainerStyled, __assign({ "data-section": dataSection }, { children: (!tablet && ((0, jsx_runtime_1.jsx)(S.TabGroupStyled, __assign({ ref: tabGroupRef, role: "tablist" }, { children: tabMenu }), void 0))) || ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(S.TabButtonMobileStyled, __assign({ bgColor: bgColor, onClick: _toggleMenuItems }, { children: [(0, jsx_runtime_1.jsx)("span", { children: tabMenuMobile[selectedTab].props.children }, void 0), (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { icon: tabMenuMobileOpen ? chevron_up_1.default : chevron_down_1.default, size: "md" }, void 0)] }), void 0), (0, jsx_runtime_1.jsx)(LftListMenu_1.default, __assign({ className: 'LftListMenu', visible: tabMenuMobileOpen, lftChange: function (e) { return _selectItemMenuMobile(e); } }, { children: tabMenuMobile }), void 0)] }, void 0)) }), void 0), (0, jsx_runtime_1.jsx)(S.TabContentsStyled, __assign({ "aria-labelledby": 'tab-' + selectedTab.toString(), id: 'tab-' + selectedTab.toString(), role: "tabpanel" }, { children: children && children[selectedTab] }), void 0)] }), void 0));
};
exports.default = LftTabGroup;
